import { GetStaticPaths, GetStaticProps } from 'next'

/* blocks */
import Layout from '@/cmp/templates/Layout/Layout'
import IndividualServices from '@/cmp/templates/IndividualServices/IndividualServices'

/* utils */
import { getStrapiGraphqlData } from '@/utils/api/wrapper'
import {
  getIndividualServicePageUrl,
  getIndividualServiceSlugType
} from '@/utils/functions/utils'
import { SERVICE_CATEGORY } from '@/utils/enums/services-category'
import { newServicesDetailsQuery } from '@/utils/queries/new_services'
import { TEN_MINS_REVALIDATION } from '@/utils/constants/revalidation'
import { constructMetadataFromStrapiData } from '@/utils/functions/strapi'
import { capture404PageError } from '@/utils/functions/elk-server'

interface Props {
  readonly page: NewServicesDetailsPageAttributes
}

function ServiceDetailsPages({ page }: Props) {
  return (
    <Layout
      title={page.seo.title}
      meta={constructMetadataFromStrapiData(page.seo)}
      canonical={getIndividualServicePageUrl(page.type, page.slug)}
    >
      <IndividualServices data={page} />
    </Layout>
  )
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = params?.slug
  const type = getIndividualServiceSlugType(slug?.[0] ?? '')

  // if slug is undefined or not matching structure of /{type}/{slug}, return 404
  if (!slug || slug.length > 2 || !type) return { notFound: true }

  const serviceCategory = SERVICE_CATEGORY[type]

  const result = await getStrapiGraphqlData<NewServicesDetailsPageQuery>(
    newServicesDetailsQuery.loc?.source.body,
    { type: serviceCategory.key, slug: slug[1] }
  )

  //   if api returns no data, return 404
  const page = result?.page?.data[0]
  if (!page) {
    capture404PageError(`/${slug[0]}/${slug[1]}/`)
    return { notFound: true }
  }

  return {
    props: {
      page: result.page.data[0].attributes
    },
    revalidate: TEN_MINS_REVALIDATION
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  return { paths: [], fallback: 'blocking' }
}

export default ServiceDetailsPages
